<template>
  <v-list :key="gruposAbiertos.join('-')">
    <v-list-item :to="{ name: 'Home' }">
      <v-list-item-icon>
        <v-icon>home</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Inicio</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <template v-for="grupo in grupos">
      <v-list-group
        v-if="grupo.visible"
        :key="grupo.key"
        :value="gruposAbiertos.includes(grupo.key)"
        @input="valor => alternarGrupo(grupo.key, valor)"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>{{ grupo.icono }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="item-title">{{
              grupo.titulo
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="item in grupo.items"
          :key="item.ruta"
          :to="{ name: item.ruta }"
        >
          <v-list-item-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
import { permisosGestionMixin } from '../mixins/Permisos/Empleados/gestionMixin';
import { permisosImportarDatosMixin } from '../mixins/Permisos/Empleados/importarDatosMixin';
import { permisosNovedadesMixin } from '../mixins/Permisos/Empleados/novedadesMixin';
import { registroDatosMixin } from '../mixins/Permisos/Empleados/registroDatosMixin';
import { permisosConsultaCreditosMixin } from '../mixins/Permisos/Empleados/consultaCreditosMixin';
import { permisosEmpleadosRetiradosMixin } from '../mixins/Permisos/Empleados/empleadosRetiradosMixin';
import { permisosAccesoMixin } from '../mixins/Permisos/user/accesoMixin';
import { permisosGestionUsuarioMixin } from '../mixins/Permisos/user/gestionUsuarioMixin';
import { permisosParametrosMixin } from '../mixins/Permisos/Configurar/parametrosMixin';
import { permisosParametrizacionCompaniaMixin } from '../mixins/Permisos/Configurar/parametrizacionCompaniaMixin';
import { permisosParametrizacionEmpresaMixin } from '../mixins/Permisos/Configurar/parametrizacionEmpresaMixin';
import { permisosLogsMixin } from '../mixins/Permisos/Log/logsMixin';

export default {
  name: 'Sidebar',
  mixins: [
    permisosGestionMixin,
    permisosImportarDatosMixin,
    permisosNovedadesMixin,
    registroDatosMixin,
    permisosConsultaCreditosMixin,
    permisosEmpleadosRetiradosMixin,
    permisosAccesoMixin,
    permisosGestionUsuarioMixin,
    permisosParametrosMixin,
    permisosParametrizacionCompaniaMixin,
    permisosParametrizacionEmpresaMixin,
    permisosLogsMixin,
  ],
  data() {
    return {
      gruposAbiertos: [],
      maxGruposAbiertos: 2,
      rutasPorGrupo: {
        novedades: [
          'registrardatos',
          'importardatos',
          'consultacredito',
          'empleadosRetirados',
          'gestion',
        ],
        acceso: ['gestionusuario'],
        sistema: ['parametrizacioncompania', 'parametrizacionempresa'],
        logs: ['log'],
      },
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(rutaActual) {
        const grupoActivo = this.obtenerGrupoPorRuta(rutaActual.name);
        if (!grupoActivo) return;

        this.gruposAbiertos = [grupoActivo];
      },
    },
  },
  computed: {
    novedades() {
      return this.$store.state.usuario && this.permisosNovedades.accesoModulo;
    },

    registerData() {
      return (
        this.$store.state.usuario && this.permisosRegistroDatos.registrarDatos
      );
    },

    moduloConsulta() {
      return (
        this.$store.state.usuario && this.permisosConsultaCreditos.accesoModulo
      );
    },

    moduloEmpleadosRetirados() {
      return (
        this.$store.state.usuario &&
        this.permisosEmpleadosRetirados.accesoModulo
      );
    },

    moduleGestion() {
      return this.$store.state.usuario && this.permisosGestion.accesoModulo;
    },

    importData() {
      return (
        this.$store.state.usuario && this.permisosImportarDatos.accesoModulo
      );
    },

    acceso() {
      return this.$store.state.usuario && this.permisosAcceso.accesoModulo;
    },

    gestionUsuarios() {
      return (
        this.$store.state.usuario && this.permisosGestionUsuario.accesoModulo
      );
    },

    sistema() {
      return this.$store.state.usuario && this.permisosParametros.accesoModulo;
    },

    company() {
      return (
        this.$store.state.usuario &&
        this.permisosParametrizacionEmpresa.accesoModulo
      );
    },

    general() {
      return (
        this.$store.state.usuario &&
        this.permisosParametrizacionCompania.accesoModulo
      );
    },

    logs() {
      return this.$store.state.usuario && this.permisosLogs.moduloLogs;
    },

    grupos() {
      return [
        {
          key: 'novedades',
          icono: 'group',
          titulo: 'Empleados',
          visible: this.novedades,
          items: [
            {
              ruta: 'registrardatos',
              label: 'Registrar Datos',
              visible: this.registerData,
            },
            {
              ruta: 'importardatos',
              label: 'Importar Datos',
              visible: this.importData,
            },
            {
              ruta: 'consultacredito',
              label: 'Consulta Para Créditos',
              visible: this.moduloConsulta,
            },
            {
              ruta: 'empleadosRetirados',
              label: 'Empleados retirados',
              visible: this.moduloEmpleadosRetirados,
            },
            {
              ruta: 'gestion',
              label: 'Gestión',
              visible: this.moduleGestion,
            },
          ].filter(item => item.visible),
        },
        {
          key: 'acceso',
          icono: 'build',
          titulo: 'Acceso',
          visible: this.acceso,
          items: [
            {
              ruta: 'gestionusuario',
              label: 'Gestión de Usuarios',
              visible: this.gestionUsuarios,
            },
          ].filter(item => item.visible),
        },
        {
          key: 'sistema',
          icono: 'settings',
          titulo: 'Parámetros',
          visible: this.sistema,
          items: [
            {
              ruta: 'parametrizacioncompania',
              label: 'Generales',
              visible: this.general,
            },
            {
              ruta: 'parametrizacionempresa',
              label: 'Empresa',
              visible: this.company,
            },
          ].filter(item => item.visible),
        },
        {
          key: 'logs',
          icono: 'find_in_page',
          titulo: 'Log',
          visible: this.logs,
          items: [{ ruta: 'log', label: 'Log', visible: true }].filter(
            item => item.visible
          ),
        },
      ];
    },
  },
  methods: {
    obtenerGrupoPorRuta(nombreRuta) {
      const entradaGrupo = Object.entries(this.rutasPorGrupo).find(
        ([, rutas]) => rutas.includes(nombreRuta)
      );

      return entradaGrupo ? entradaGrupo[0] : null;
    },

    alternarGrupo(nombreGrupo, abierto) {
      if (!abierto) {
        this.gruposAbiertos = this.gruposAbiertos.filter(
          grupo => grupo !== nombreGrupo
        );
        return;
      }

      if (this.gruposAbiertos.includes(nombreGrupo)) return;

      const nuevosGrupos = [...this.gruposAbiertos, nombreGrupo];

      if (nuevosGrupos.length <= this.maxGruposAbiertos) {
        this.gruposAbiertos = nuevosGrupos;
        return;
      }

      const grupoActivo = this.obtenerGrupoPorRuta(this.$route.name);
      const tieneActivo = grupoActivo && nuevosGrupos.includes(grupoActivo);

      const otros = tieneActivo
        ? nuevosGrupos.filter(grupo => grupo !== grupoActivo)
        : nuevosGrupos;

      const cupoOtros = tieneActivo
        ? this.maxGruposAbiertos - 1
        : this.maxGruposAbiertos;

      const otrosRecortados = otros.slice(otros.length - cupoOtros);

      this.gruposAbiertos = tieneActivo
        ? [...otrosRecortados, grupoActivo]
        : otrosRecortados;
    },
  },
};
</script>

<style scoped>
.item-title {
  width: 81px;
}
</style>
